import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

const selectOptions = [
  { name: "Male", value: "Male" },
  { name: "Female", value: "Female" },
];

const BirthGender = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("Gender", value);
    setLastUpdate({ key: "Gender", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex h-max flex-col gap-3">
      <p className="text-bold1 text-primary">What is your gender?</p>
      <div className="flex flex-wrap gap-3">
        {selectOptions.map((option) => {
          return (
            <Option
              key={option.value}
              name={option.name}
              value={option.value}
              checked={props.data.Gender === option.value}
              onChange={(e) => handleChange(option.value)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BirthGender;
